import {prefix} from "app/config/routes/pp/_cfg";

export const routePPTrainers = {
    'pp.playerTrainers':         `${prefix}/my-trainers`,
    'pp.playerTrainers.invites': `${prefix}/my-trainers/invites`,
}